import React from 'react';
import './QuoteSection.css';

function QuoteSection() {
  return (
    <section className="quote-section">
      <div className="quote-container">
        <blockquote className="quote-blockquote">
          <div className="quote-content">
            <span className="quote-mark quote-mark-start">"</span>
            <p className="quote-text">
              As a community, we provide strategic advisory on quantum adoption, support talent acquisition, and empower startups driving quantum innovation.
            </p>
            <span className="quote-mark quote-mark-end">"</span>
          </div>
        </blockquote>
      </div>
    </section>
  );
}

export default QuoteSection;